import { render, staticRenderFns } from "./faq_login.vue?vue&type=template&id=5d578a9b&scoped=true"
import script from "./faq_login.vue?vue&type=script&lang=js"
export * from "./faq_login.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d578a9b",
  null
  
)

export default component.exports